<template>
    <SmuMenuDropdown v-if="languages" v-model="locale" :items="languageKeys">
        <template #value>{{ locale.toUpperCase() }}</template>
        <template #item="{ item }">
            <div class="w-full" @click="setLocale(item)">
                {{ languages[item] }}
            </div>
        </template>
    </SmuMenuDropdown>
</template>

<script setup lang="ts">
const { setLocale } = useLocalSettingsStore();
const { locale } = storeToRefs(useLocalSettingsStore());
const { t } = useI18n();

const { data } = storeToRefs(useUserStore());

const fallbackLanguageCodes = [
    "de",
    "en",
    "nl",
    "fr",
    "ar",
    "sv",
    "pl",
    "tr",
    "es",
    "ko",
    "ja",
    "it",
    "cs",
    "da",
    "sk",
    "hu",
];

const languages = computed(() => {
    if (data.value?.locales.length) {
        return Object.fromEntries(
            data.value.locales.map((l) => [
                l.code,
                l.name[locale.value] ?? l.name[l.code],
            ]),
        );
    }

    return Object.fromEntries(
        fallbackLanguageCodes.map((code) => [
            code,
            t(`helpers.language.${code}`),
        ]),
    );
});

const languageKeys = computed(() => Object.keys(languages.value));
</script>
